import { SessionStorage } from 'common/CookieStorage'
import { Environment } from 'enviroment/AppSettings'
import { STORAGEKEYS } from 'enviroment/Keys'
import { SpecialHandlingBrokers } from 'models/responses/AuthSuccesfullResponse'

/**
 * Funkcja która po podaniu numeru telefonu zwraca przygotowany string do wstawienia w atrybut `href` znacznika `<a />`.
 * Dzięki dodaniu 'tel:' po kliknięciu w taki odnośnik, na urządzeniach mobilnych zostanie otwarta aplikacja do wykonywania połączeń. 
 * @param phoneNumber - Numer telefonu
 * @returns 
 */
export const preparePhoneNumberToHref = (phoneNumber: string | undefined) => {
   if(phoneNumber?.length){
      let phoneNumberTemp = ''
      const phonePrefix = Environment.phoneNumberPrefix.trim()
      
      if(phoneNumber.startsWith(phonePrefix)){
         phoneNumberTemp = phoneNumber.replaceAll(/\s/g, '')
      }
      else {
         phoneNumberTemp = `${phonePrefix}${phoneNumber}`.replaceAll(/\s/g, '')
      }

      return `tel:${phoneNumberTemp}`.replaceAll(/\s/g, '')
   }

   else return ''
}


/**
 * Funkcja tworząca GUIDa
 * @returns {GUID} 
 */
export function Guid(): string
{
    var array = new Uint16Array(8);
    (window.crypto || window.Crypto).getRandomValues(array);
    var dataView = new DataView(array.buffer);

    var parts = [];

    for(var i = 0; i < array.length; ++i)
    {
        // 0&1,2,3,4,5-7 dataView.getUint16(0-7)
        if(i>1 && i<6) parts.push("-");
        parts.push(dataView.getUint16(i).toString(16).padStart(4, '0'));
    }

    parts[5] = "4" + parts[5].substr(1);
    return parts.join('').toLowerCase();// .toUpperCase();
}

/**
 * Funkcja pomocnicza która opóźnia wykonanie danego kawałka kodu o określoną parametrem liczę minisekund. 
 * Realizuje ona mechanizm "czekania" na wykonanie dalszego kawałka kodu
 * 
 * @param time - czas w milisekundach na jaki wykonanie funkcji ma zostać opóźnione
 * @returns 
 */
export const sleep = (time: number) => new Promise(r => setTimeout(r, time));


/**
 * Funkcja sprawdzająca czy aktualny brokerLevel3 to TRASTI, używana w celu wyświetlenia dostosowanych treści na stronie, tylko dla Brokera "TRASTI"
 */
export const isTrastiBroker = (): boolean => {
   const sessionStorage = new SessionStorage()

   if (!sessionStorage.get(STORAGEKEYS.SPECIAL_HANDLING_BROKER_NAME)) {
      return false;
   }

   return sessionStorage.get(STORAGEKEYS.SPECIAL_HANDLING_BROKER_NAME).toLowerCase() === SpecialHandlingBrokers.TRASTI.toLowerCase()
}